import type { ReactNode } from "react";

import { cn } from "#/lib/utils";

type SectionHeaderProps = {
  children: ReactNode;
  className?: string;
};

export function PageHeader({ children, className }: SectionHeaderProps) {
  return (
    <h1
      className={cn(
        "text-3xl font-bold tracking-tight text-foreground uppercase sm:text-4xl",
        className,
      )}
    >
      {children}
    </h1>
  );
}
